"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuidedFlowStore = void 0;
var Utils_1 = require("./Utils");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var GuidedFlowStore = (function () {
    function GuidedFlowStore() {
        var _this = this;
        this._steps = [];
        this._currentStepId = null;
        this._coords = { x: 0, y: 0 };
        this.getStep = function (id) {
            return _this._steps.find(function (step) { return step.id === id; });
        };
    }
    GuidedFlowStore.getInstance = function () {
        if (!GuidedFlowStore.instance) {
            GuidedFlowStore.instance = new GuidedFlowStore();
        }
        return GuidedFlowStore.instance;
    };
    GuidedFlowStore.prototype.registerSteps = function (incomingSteps, makeLabel) {
        var existingSteps = new Map(this._steps.map(function (step) { return [step.id, step]; }));
        this._steps = incomingSteps.map(function (step) {
            var _a, _b;
            return (__assign(__assign({}, step), { completed: (_b = (_a = existingSteps.get(step.id)) === null || _a === void 0 ? void 0 : _a.completed) !== null && _b !== void 0 ? _b : false, label: makeLabel(step.subType, step.id) }));
        });
    };
    GuidedFlowStore.prototype.updateStep = function (id, payload) {
        var index = this._steps.findIndex(function (step) { return step.id === id; });
        if (index !== -1 && this._steps[index]) {
            this._currentStepId = id;
            var clonedSteps = (0, lodash_1.cloneDeep)(this._steps);
            clonedSteps.splice(index, 1, __assign(__assign({}, this._steps[index]), payload));
            this._steps = clonedSteps;
        }
    };
    GuidedFlowStore.prototype.incrementStep = function (startingFrom) {
        var _a, _b;
        var next = (0, Utils_1.getNextPendingStep)(this._steps, (_a = startingFrom !== null && startingFrom !== void 0 ? startingFrom : this.currentStepId) !== null && _a !== void 0 ? _a : undefined);
        this._currentStepId = next;
        if (next) {
            return (_b = this.getStep(next)) !== null && _b !== void 0 ? _b : null;
        }
        return null;
    };
    GuidedFlowStore.prototype.setCoords = function (coords) {
        this._coords = coords;
    };
    GuidedFlowStore.prototype.getStepIdAtIndex = function (index) {
        var _a, _b;
        return (_b = (_a = this._steps[index]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
    };
    Object.defineProperty(GuidedFlowStore.prototype, "coords", {
        get: function () {
            return this._coords;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuidedFlowStore.prototype, "getCurrentStepIndex", {
        get: function () {
            var _this = this;
            return this._steps.findIndex(function (step) { return step.id === _this._currentStepId; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuidedFlowStore.prototype, "allStepsCompleted", {
        get: function () {
            return this._steps.every(function (step) { return step.completed; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuidedFlowStore.prototype, "currentStepId", {
        get: function () {
            return this._currentStepId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuidedFlowStore.prototype, "currentStepState", {
        get: function () {
            var _this = this;
            return this._steps.find(function (step) { return step.id === _this._currentStepId; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuidedFlowStore.prototype, "hasSteps", {
        get: function () {
            return this._steps.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], GuidedFlowStore.prototype, "_steps", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], GuidedFlowStore.prototype, "_currentStepId", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], GuidedFlowStore.prototype, "_coords", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Function]),
        __metadata("design:returntype", void 0)
    ], GuidedFlowStore.prototype, "registerSteps", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, typeof (_a = typeof Partial !== "undefined" && Partial) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], GuidedFlowStore.prototype, "updateStep", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], GuidedFlowStore.prototype, "incrementStep", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], GuidedFlowStore.prototype, "setCoords", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], GuidedFlowStore.prototype, "getStepIdAtIndex", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], GuidedFlowStore.prototype, "coords", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], GuidedFlowStore.prototype, "getCurrentStepIndex", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], GuidedFlowStore.prototype, "allStepsCompleted", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], GuidedFlowStore.prototype, "currentStepId", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], GuidedFlowStore.prototype, "currentStepState", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], GuidedFlowStore.prototype, "hasSteps", null);
    return GuidedFlowStore;
}());
exports.GuidedFlowStore = GuidedFlowStore;
